import React from 'react';
import styled from 'styled-components';
import Section from '../../components/section';
import Form from './form-component';

const FormSection = styled(Section)``;

const FormBlock = ({
  rowOptions,
  strapiFormForm,
  className,
  ...props
}) => (!strapiFormForm ? null : (
  <FormSection
    id={rowOptions?.sectionId}
    backgroundColor={rowOptions?.backgroundColor}
    hideBottomSpacing={rowOptions?.hideBottomSpacing}
    hideTopSpacing={rowOptions?.hideTopSpacing}
    hideRow={rowOptions?.hideRow}
    className={className}
  >
    <Form
      backgroundColor={rowOptions?.backgroundColor}
      strapiFormForm={strapiFormForm}
      {...props}
    />
  </FormSection>
));

export default styled(FormBlock)``;
